require('../global/global');
require('../global/base/layout.scss');
require('../global/css/crumbs.scss');
require('./list/index.scss');
require('../global/css/loading.scss');
require('../global/js/content-min-height')();
require('../global/js/toTop');

const $ = require('../jquery');
const listItemTpl = require('../../../view/partial/list-item.hbs');
$(function () {
    const listContainerEl = $('#listContainer');
    const loadingBoxEl = $('#loadingBox');
    const loadMoreEl = $('#loadMore');

    let pageIndex = 1, pageSize = 10;

    $(document).on('click', '#loadListBtn', function () {
        pageIndex++;

        const params = {
            pageIndex,
            pageSize
        };

        loadingBoxEl.show();

        $.ajax('/list', {
            data: params
        }).then(result => {
            loadingBoxEl.hide();

            if (result.code !== '0') {
                pageIndex--;
                throw new Error(`code:${result.code},msg:${result.msg}`);
            }

            const data = result.data;

            listContainerEl.append(listItemTpl(data));

            if(data.dataCount <= data.pageSize * data.pageIndex){
                loadMoreEl.addClass('is-end');
            }
        });
    });
});



//////////////////
// WEBPACK FOOTER
// ./src/project/list.page.js
// module id = 44
// module chunks = 1